import React, { useState } from 'react';

import Dropdown from '../dropdown';
import type { Predicate } from '@common/types/objects';
import { EPredicateOperators } from '@common/definitions';

type Option = Record<string, string>;

type PredicateSelectorSingleSelectOwnProps = {
  predicate: Predicate,
  onChange: (newPredicate: Partial<Predicate>) => void,
  options: Option[];
  labelKey: string;
  valueKey: string;
  isSearchable?: boolean;
  isSortable?: boolean;
};

export const PredicateSelectorSingleSelect = ({
  predicate, onChange: parentOnChange,
  options = [], labelKey = 'name', valueKey = 'id',
  isSearchable = true,
  isSortable = true,
}: PredicateSelectorSingleSelectOwnProps) => {
  const [search, setSearch] = useState('');

  const searchText = search && search.toLowerCase();
  const safeOptions = Array.isArray(options) ? options : [options];
  const filteredOptions = safeOptions.filter((option) => option[labelKey]?.toLowerCase().indexOf(searchText) > -1);

  const onChange = ({ value }: Partial<Predicate>) => parentOnChange({ comparison: EPredicateOperators.EQ, value });

  return (
    <>
      {isSearchable && (
        // @ts-expect-error
        <Dropdown.SearchInput debounce={false} filter={false} onSearch={setSearch} />
      )}
      {filteredOptions
        .sort((a, b) => {
          if (!isSortable) return 0;
          if (predicate.value === a[valueKey] && predicate.value !== b[valueKey]) return -1;
          if (predicate.value === b[valueKey] && predicate.value !== a[valueKey]) return +1;

          return a[labelKey] > b[labelKey] ? 1 : -1;
        })
        .map((option) => (
          <Dropdown.Item
            key={option[valueKey]}
            disabled={!!option?.disabled}
            selected={predicate.value === option[valueKey]}
            onClick={() => onChange({ value: option[valueKey] })}
          >
            {option[labelKey]}
          </Dropdown.Item>
        ))}
    </>
  );
};
